import { useLingui } from "@lingui/react/macro";
import { EyeIcon } from "lucide-react";

import { useSettings, useUpdateSettings } from "../../hooks/useSettings";
import { Switch } from "../ui/switch";
import { SettingsRow, SettingsSection } from "./settingsLayout";
import { useInspectScope } from "./useInspectAccess";

/** A personal switch of an administrator's session; off, the chat reads as a user sees it. */
export function InspectSettingsSection() {
  const { t } = useLingui();
  const { hasScope } = useInspectScope();
  const developerView = useSettings((settings) => settings.developerView);
  const { updateSettings } = useUpdateSettings();

  if (!hasScope) {
    return null;
  }

  return (
    <SettingsSection title={t`Developer settings`} icon={<EyeIcon className="size-4" />}>
      <SettingsRow
        title={t`Verbose output`}
        description={t`Commands, arguments, results and diffs of steps, developer-only steps, provider warnings and model parameters.`}
        control={
          <Switch
            checked={developerView}
            onCheckedChange={(checked) => updateSettings({ developerView: Boolean(checked) })}
            aria-label={t`Verbose output`}
          />
        }
      />
    </SettingsSection>
  );
}
